<template>
  <div>
    <v-form ref="form">
      <v-layout>
        <v-text-field
          v-model="itemSelected"
          class="mr-2"
          label="Tag"
          clearable
          :rules="$isRequiredRule"
        ></v-text-field>

        <v-btn fab small dark color="primary" @click="confirmCustom">
          <v-icon v-if="indexSelected != null">mdi-pencil</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
      </v-layout>
    </v-form>
    <v-list>
      <div v-for="(tag,i) in value" :key="i">
        <v-list-item>
          <v-list-item-title>{{tag}}</v-list-item-title>
          <v-list-item-action>
            <v-layout>
              <v-btn icon color="warning" @click="edit(tag,i,true)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="error" @click="remove(i)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-layout>
          </v-list-item-action>
        </v-list-item>
        <v-divider></v-divider>
      </div>
    </v-list>
  </div>
</template>

<script>
import objectValueListMixing from "@/mixins/objectPageLists/objectValueListMixing.js";
export default {
  name: "item-tag-list",
  props: ["value"],
  mixins: [objectValueListMixing],

  watch: {
    indexSelected() {},
  },
  methods: {
    confirmCustom() {
      let validate = this.$refs.form.validate();
      this.confirm(true, validate);
      if (validate) this.$refs.form.resetValidation();
    },
  },
};
</script>